import React from 'react'

import { Typography } from '@material-ui/core'
import { builder, BuilderComponent } from '@builder.io/react'

builder.init('32eea804311a4d17817f2e534ded7af8')

const Welcome = ({ title, ...props }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <Typography paragraph variant='h1' style={{ fontSize: '2em', textTransform: 'uppercase', fontWeight: 'bold' }}>
        Vind med GLFR
      </Typography>

      <Typography paragraph>
        Alle danske GLFR brugere kan gratis tilmelde sig vores sæsonkonkurrence hvor du kan vinde fantastiske golf præmier.
      </Typography>

      <Typography paragraph>
        Hver uge trækker vi vindere tilfældigt blandt alle deltagere, som vinder præmier fra vores partnere - lige fra Pro V1'ere og poloer til golfoplevelser og ure.
      </Typography>

      <Typography paragraph>
        I slutningen af sæsonen trækker vi 3 vindere blandt alle deltagere, som vinder en golfrejse for to sponsoreret af Bravo Golf.
      </Typography>

      <div>
        <BuilderComponent
          model='content-sections'
          entry='ca33a4db7f684cf9bb420aa164debe2b'
        />
      </div>
    </div>
  )
}

export default Welcome
